import { render, staticRenderFns } from "./CMChangePasswordPopup.vue?vue&type=template&id=a445289c&"
import script from "./CMChangePasswordPopup.vue?vue&type=script&lang=js&"
export * from "./CMChangePasswordPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports